import { render } from "./ShowRent.vue?vue&type=template&id=63325be2&scoped=true"
import script from "./ShowRent.vue?vue&type=script&lang=js"
export * from "./ShowRent.vue?vue&type=script&lang=js"

import "./ShowRent.vue?vue&type=style&index=0&id=63325be2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63325be2"]])

export default __exports__